function initAlldaycoolSliders() {
  document.querySelectorAll('[data-alldaycool-image-slider]').forEach(function (el) {
    var slidesMobile = parseFloat(el.dataset.slidesMobile) || 1.2;
    var slidesDesktop = parseFloat(el.dataset.slidesDesktop) || 2.5;
    var slideGap = parseInt(el.dataset.slideGap, 10) || 0;
    var scrollbarEl = el.querySelector('.swiper-scrollbar');

    new Swiper(el, {
      slidesPerView: slidesMobile,
      spaceBetween: slideGap,
      threshold: 10,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: true,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: slideGap,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initAlldaycoolSliders);
